export enum TimeoutTypeEnum {
  INACTIVITY = 'Inactivity',
  TOKEN = 'Token'
}
